'use client';
import { MainPageArticleBlock } from '@/types/ssr';

import { Card } from './Card';
import { CardsGrid } from './utils';

export function CardList({ list, defaultIconName }: { list?: MainPageArticleBlock[] } & { defaultIconName?: string }) {
  if (!list) return null;

  return (
    <CardsGrid>
      {list.map(({ title, description, url, icon }) => (
        <Card
          defaultIconName={defaultIconName}
          key={title}
          title={title}
          description={description}
          iconName={icon}
          link={url}
        />
      ))}
    </CardsGrid>
  );
}
